import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_staging/69fbac62f6558f0014fa166d/davetheprinter/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69fbac62f6558f0014fa166d/davetheprinter/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69fbac62f6558f0014fa166d/davetheprinter/src/components/Header.tsx");
